export const UNSPLASH_ATTRIBUTION_UTM = 'utm_source=giftly_customizer_design_search&utm_medium=referral'
